import { Container, Eyebrow } from './primitives'

type Client = {
  name: string
  logo: string
  fit?: 'contain' | 'cover'
}

const CLIENTS: Client[] = [
  { name: 'Lab Digital', logo: '/clients/lab_digital.webp' },
  { name: 'Lukkien', logo: '/clients/lukkien.jpeg' },
  { name: 'BauWatch', logo: '/clients/bauwatch.webp' },
  { name: 'Eurocom', logo: '/clients/eurocom.jpeg', fit: 'cover' },
]

export function Signature() {
  return (
    <section style={{ padding: '80px 0 40px' }}>
      <Container>
        <div
          className="signature-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 48,
            alignItems: 'center',
            borderTop: '1px solid var(--line)',
            paddingTop: 48,
          }}
        >
          <div style={{ maxWidth: 520 }}>
            <Eyebrow>One designer. One builder.</Eyebrow>
            <p
              style={{
                fontSize: 20,
                lineHeight: 1.5,
                margin: '18px 0 0',
                letterSpacing: '-0.01em',
              }}
            >
              Vello is{' '}
              <a
                href="https://www.linkedin.com/in/thijs-smudde/"
                target="_blank"
                rel="noreferrer"
                style={{
                  borderBottom: '1.5px solid var(--accent)',
                  fontWeight: 500,
                }}
              >
                Thijs Smudde
              </a>
              , an independent designer and engineer. Over ten years of
              experience shipping products at agencies and tech companies, such
              as Lab Digital, Lukkien, BauWatch, and Eurocom. Same hands on
              your site.
            </p>
          </div>

          <div
            className="client-row"
            style={{
              display: 'flex',
              gap: 32,
              flexWrap: 'wrap',
              justifyContent: 'flex-end',
            }}
          >
            {CLIENTS.map((c) => (
              <ClientChip key={c.name} client={c} />
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}

function ClientChip({ client }: { client: Client }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: client.fit === 'cover' ? '50%' : 8,
          overflow: 'hidden',
          flexShrink: 0,
        }}
      >
        <img
          src={client.logo}
          alt={`${client.name} logo`}
          width={40}
          height={40}
          loading="lazy"
          style={{ width: '100%', height: '100%', objectFit: client.fit ?? 'contain', display: 'block' }}
        />
      </div>
      <span
        style={{
          fontSize: 14,
          fontWeight: 500,
          letterSpacing: '-0.01em',
        }}
      >
        {client.name}
      </span>
    </div>
  )
}
